import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBranchRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.6 7.4v4.8h4.8V7.4zm-2.4 0c0-1.3 1-2.4 2.4-2.4h4.8c1.3 0 2.4 1 2.4 2.4v1.2h6.4V7.4c0-1.3 1-2.4 2.4-2.4h4.8c1.3 0 2.4 1 2.4 2.4v4.8c0 1.3-1 2.4-2.4 2.4h-4.8c-1.3 0-2.4-1-2.4-2.4V11h-6.4v1.2q0 .8-.4 1.4l3.1 4.2H20c1.3 0 2.4 1 2.4 2.4V25c0 1.3-1 2.4-2.4 2.4h-4.8c-1.3 0-2.4-1-2.4-2.4v-4.8q0-.8.5-1.4L10 14.6H5.6c-1.3 0-2.4-1-2.4-2.4zm12 12.8V25H20v-4.8zM26.4 7.4h-4.8v4.8h4.8z" })
});
export default SvgBranchRegularIcon;
